export default {
	and_more_dates_plural: 'And {dates} more dates',
	and_more_dates: 'And {dates} more date',
	attend_this_face_to_face_class_at_the_address_indicated:
		'Attend this Face-to-Face class at the address indicated',
	awaiting_results: 'Awaiting results',
	canceled: 'Canceled',
	check_your_availability_at_all_times_before_confirming_your_presence:
		'Check your availability at all times before confirming your presence.',
	class_date: 'Class date',
	closed: 'Invited only',
	do_you_confirm_your_registration_for_the_presential_class:
		'Do you confirm your registration for the {title} Face-to-Face class?',
	do_you_confirm_your_unsubscription_to_the_presential_class:
		'Do you confirm your unsubscription to the {title} Face-to-Face class?',
	end_time: 'End time',
	event_type: 'Event type',
	finished: 'Finished',
	in_progress: 'In progress',
	intermission: 'Interval',
	live: 'Live',
	loading_presential_classes: 'Loading Face-to-Face classes',
	model: 'Model',
	next: 'Next',
	no_presential_classes_are_available_at_the_moment:
		'There are currently no Face-to-Face classes available',
	no_presential_classes_are_available_with_the_selected_filter:
		'There are no Face-to-Face classes available for the selected filter',
	opened: 'Open',
	please_wait_for_instructor_presence_check: 'Please wait for instructor validation',
	pre_scheduled: 'Pre-scheduled',
	presential_class_offline: 'Face-to-Face class offline',
	presential_event: 'Face-to-Face class',
	receive_emails_about_this_presential_class: 'Receive emails about this Face-to-Face class',
	register_for_the_presential_class: 'Register for the Face-to-Face class',
	reproved: 'Disapproved',
	scheduled: 'Scheduled',
	start_time: 'Start time',
	subscribe: 'Subscribe',
	subscribed: 'Subscribed',
	successfully_signed_up_for_the_presential_class:
		'Successfully signed up for the Face-to-Face class',
	this_class_has_already_ended_finish_the_rest_of_the_days_activities:
		"This class has already ended. Finish the rest of the day's activities",
	this_class_has_already_ended: 'This class has already ended.',
	transmission_date: 'Transmission Date',
	transmission_finished: 'Transmission Finished',
	unsubscribe_from_the_presential_class: 'Unsubscribe from the Face-to-Face class',
	unsubscribe_successfully_for_the_presential_class:
		'Unsubscribe successfully for the Face-to-Face class',
	unsubscribe: 'Unsubscribe',
	you_already_have_a_certificate_for_this_type_of_event:
		'You already have a certificate for this type of event',
	your_presential_class_will_start_soon_please_wait:
		'Your Face-to-Face class will start soon, please wait',
}
